<template>
<!-- 自动提现配置 -->
<el-dialog title="自动提现配置" :visible.sync="dialogVisible" :close-on-click-modal="closeModal" :close-on-press-escape="closeEscape" :before-close="close" class="dialog-container" width="800px">
  <div class="config-form-wrapper"> 
    <el-form :model="configForm" ref="configForm" :rules="configRules">
      <el-form-item label="" prop="autoWithdraw">
        <el-radio-group v-model="configForm.autoWithdraw" @change="changeAutoWithdraw">
          <el-radio :label="true" :disabled="!supportsAutoWithdraw">
            开启每天自动提现
            <el-popover width="230" trigger="hover" content="自动提现功能升级中，待完成后恢复使用">
              <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
            </el-popover>
          </el-radio>
          <el-radio :label="false">关闭每天自动提现</el-radio>
        </el-radio-group>
        <div>提示：关闭每天自动提现后，您可以通过手动操作提现把账户内结算资金提到您的绑定的银行卡内。</div>
      </el-form-item>
      <el-form-item label="选择自动提现时间" prop="withdrawTimeList">
        <!-- <el-radio-group v-model="configForm.withdrawTimeList" :disabled="!configForm.autoWithdraw" class="time-group">
          <el-radio v-for="(item,index) in timeOptions" :key="index" :label="item">{{item}}</el-radio>
        </el-radio-group> -->
        <el-select v-model="configForm.withdrawTimeList" :disabled="!configForm.autoWithdraw" multiple :multiple-limit="3" placeholder="请选择">
          <el-option v-for="(item, index) in timeOptions" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
  <div slot="footer" class="dialog-footer">
    <el-button size="mini" @click="close({})">取 消</el-button>
    <el-button size="mini" type="primary" :loading="submitLoading" @click="confirmSign">保 存</el-button>
  </div>
</el-dialog>
</template>

<script>
import dialog from '@mix/dialog'
import { updateWithdrawTypeApi,getAutoWithdrawTimeApi } from '@/api/finance'
import dayjs from 'dayjs'

export default {
  mixins: [dialog],
  props: {
    info: {
      type: Object,
      default: () => ( {} )
    },
    signBody: {
      type: String,
      default: ''
    },
    supportsAutoWithdraw: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkWithDrawTime = (rule, value, callback) => {
      if (this.configForm.autoWithdraw && !value) {
        callback(new Error('请选择提现时间'))
      } else {
        callback()
      }
    }
    return {
      configForm: {
        autoWithdraw: false,
        withdrawTimeList: [],
        accountCode:''
      },
      submitLoading: false,
      configRules:{
        autoWithdraw:[
          {required: true, message: '请选择提现方式', trigger: 'blur'}
        ],
        withdrawTimeList:[
          {validator: checkWithDrawTime, trigger: 'change'}
        ]
      },
      timeOptions: []    //4种账户交集
    }
  },
  created() {
    this.initTimeOptions()
    // 获取商户ID（vuex或者sessionStorage）
    this.initPage()
  },
  methods: {
    initTimeOptions() {
      let time = dayjs().format('YYYY-MM-DD 00:00:00')
      this.timeOptions.push('00:00')
      while (dayjs(time).format('HH:mm') !== '23:30') {
        time = dayjs(time).add(30, 'minute').format('YYYY-MM-DD HH:mm:ss')
        this.timeOptions.push(dayjs(time).format('HH:mm'))
      }
    },
    initPage(){
      this.configForm = this.info
      // this.getAutoWithdrawTime(this.info.accountCode)
    },
    changeAutoWithdraw(value){
      if(!value){
        this.configForm.withdrawTimeList = []
      }
    },
    //修改提现方式
    async confirmSign() {
      this.$refs['configForm'].validate(async valid=>{
        if(valid){
          this.$track.clickEvent('提现资金管理-自动提现', '1621476237', {
            tysj_date_type: this.configForm.autoWithdraw
          })
          this.submitLoading = true
          const {code} = await updateWithdrawTypeApi({ ...this.configForm, signBody: this.signBody, withdrawTimeList: this.configForm.withdrawTimeList.join(',') })
          if(code === 200){
            this.$message.success('设置成功');
            this.close(this.configForm)
            this.submitLoading = false
          }else{
            this.submitLoading = false
          }
        }
      })
    },
    // 获取账户提现时间
    async getAutoWithdrawTime(accountCode){
      try{
        const {code, result = []} = await getAutoWithdrawTimeApi({accountCode})
        if(code!==200) return
        this.timeOptions = result
      }catch(e){
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.config-form-wrapper {
  /deep/.el-radio-group {
    font-size: 0;
    line-height: 25px;

    .el-radio {
      margin-right: 60px;
      width: 121px;
      margin-bottom: 8px;
    }
  }
  .time-group{
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
